import { scheudleService } from "@/services/api/features/scheduleService";
import { executeAction, executeDownloadAction } from "@/services/api/helpers";

const scheduleModules = {
  namespaced: true,

  state: () => ({
    loading: {},
    error: {},
    filterList: [],
    holiday: [],
    conflictHoliday: [],
    excelOption: [],
  }),

  getters: {
    holidayList: (state) => state.holiday,
    conflictHolidayList: (state) => state.conflictHoliday,
    getFilterList: (state) => state.filterList,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_FILTER_LIST: (state, list) => (state.filterList = list),
    SET_HOLIDAY_LIST: (state, holiday) => (state.holiday = holiday),
    SET_EXCEL_OPTION: (state, excelOption) =>
      (state.scheduleExcelOption = excelOption),
    SET_CONFLICT_HOLIDAY_LIST: (state, conflictHoliday) =>
      (state.conflictHoliday = conflictHoliday),
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },

  actions: {
    async getScheduleFilterList({ commit }) {
      return executeAction(
        { commit, action: "getScheduleFilterList" },
        () => scheudleService.getScheduleFilterList(),
        { success: (data) => commit("SET_FILTER_LIST", data.data) }
      );
    },

    async getAdminScheduleList({ commit }, params) {
      return executeAction({ commit, action: "getAdminScheduleList" }, () =>
        scheudleService.getAdminScheduleList(params)
      );
    },
    async getTodaySchedule({ commit }) {
      return executeAction({ commit, action: "getTodaySchedule" }, () =>
        scheudleService.getTodaySchedule()
      );
    },

    //---- holiday management ----

    async getHolidaysList({ commit }) {
      return executeAction(
        { commit, action: "getHolidaysList" },
        () => scheudleService.getHolidaysList(),
        { success: (data) => commit("SET_HOLIDAY_LIST", data.data) }
      );
    },
    async getConflictHolidaysList({ commit }) {
      return executeAction(
        { commit, action: "getConflictHolidaysList" },
        () => scheudleService.getConflictHolidaysList(),
        { success: (data) => commit("SET_CONFLICT_HOLIDAY_LIST", data.data) }
      );
    },
    async getConfilctHoliday({ commit }, date) {
      return executeAction({ commit, action: "getConfilctHoliday" }, () =>
        scheudleService.getConfilctHoliday(date)
      );
    },

    async postHoliday({ commit }, payload) {
      return executeAction({ commit, action: "postHoliday" }, () =>
        scheudleService.postHoliday(payload)
      );
    },
    async deleteHoliday({ commit }, holidayId) {
      return executeAction({ commit, action: "deleteHoliday" }, () =>
        scheudleService.deleteHoliday(holidayId)
      );
    },
    async patchHoliday({ commit }, { holidayId, payload }) {
      return executeAction({ commit, action: "patchHoliday" }, () =>
        scheudleService.patchHoliday(holidayId, payload)
      );
    },

    //--- Admin Schedule Excel ------

    async getScheduleExcelOption({ commit }, payload) {
      return executeAction(
        { commit, action: "getScheduleExcelOption" },
        () => scheudleService.getScheduleExcelOption(payload),
        { success: (data) => commit("SET_EXCEL_OPTION", data.data) }
      );
    },
    async getCoachCheckInExcel({ commit }, payload) {
      return await executeDownloadAction(
        { commit, action: "getCoachCheckInExcel" },
        () => scheudleService.getCoachCheckInExcel(payload),
        "CoachCheckIn_Report.xls"
      );
    },


    // ---------- Admin Timetable Management ---------------------
    async getTimeTableList({ commit },params) {
      return executeAction({ commit, action: "getTimeTableList" }, () =>
        scheudleService.getTimeTableList(params)
      );
    },
    async getTimeTableStudentList({ commit },params) {
      return executeAction({ commit, action: "getTimeTableStudentList" }, () =>
        scheudleService.getTimeTableStudentList(params)
      );
    },
    async postClassTimeTable({ commit }, payload) {
      return executeAction({ commit, action: "postClassTimeTable" }, () =>
        scheudleService.postClassTimeTable(payload)
      );
    },


  },
};

export default scheduleModules;
